import React from 'react';
import PropTypes from 'prop-types';

const P_STYLE = {color: '#E74C3C', marginTop: '6px', fontWeight: 'normal'};

export class CheckBoxMessage extends React.Component {
	render() {
		const {isUsingEmailPlus,emailOrder} = this.props;

		if (emailOrder === 1) {
			return <p style={P_STYLE}>Check this to enable 1st email.</p>;
		}

		if (isUsingEmailPlus) {
			if (emailOrder === 2) {
				return <p style={P_STYLE}>Check this to enable 2nd email.</p>;
			} else if (emailOrder === 3) {
				return <p style={P_STYLE}>Check this to enable 3rd email.</p>;
			}
		} else {
			return <p style={P_STYLE}>Try out our Email+ premium feature to enable this feature.</p>;
		}
		return (<div />);
	}
}

CheckBoxMessage.propTypes = {
	isUsingEmailPlus: PropTypes.bool.isRequired,
	emailOrder: PropTypes.number.isRequired
};

export default CheckBoxMessage;



// WEBPACK FOOTER //
// ./src/containers/dashboard-emails-settings-page/components/check-box-message.jsx